var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtUser05Tick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#ECFDF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6473 17.3077C12.6473 19.0985 13.1865 20.7785 14.1231 22.1538H8.88196C7.90752 22.1538 7.00876 21.6831 6.46951 20.88C5.93971 20.0954 5.85457 19.1077 6.23299 18.2492C6.952 16.6338 8.16295 15.3323 9.66719 14.4831C10.4997 15.2862 11.5877 15.8585 12.7892 16.0523C12.6946 16.3569 12.6473 16.6708 12.6473 17.0031V17.3077ZM13.546 14.76C13.7636 14.52 14.0285 14.3169 14.3218 14.1508L17.51 12.3877C17.6425 12.3138 17.7749 12.2585 17.9168 12.2031C18.1817 11.6492 18.3236 11.0308 18.3236 10.3846C18.3236 7.96615 16.3085 6 13.8299 6C11.3512 6 9.33607 7.96615 9.33607 10.3846C9.33607 12.7108 11.1998 14.6215 13.546 14.76ZM24 17.0049V17.3077C24 20.46 22.0369 23.2006 19.2252 23.9742C19.1628 23.9917 19.0975 24 19.0332 24C18.9689 24 18.9036 23.9917 18.8411 23.9742C16.0294 23.2015 14.0664 20.46 14.0664 17.3077V17.0049C14.0664 16.3089 14.4306 15.6766 15.0162 15.3545L18.2092 13.5978C18.7248 13.3135 19.3416 13.3135 19.8572 13.5978L23.0502 15.3545C23.6358 15.6766 24 16.3089 24 17.0049ZM20.9537 17.28C20.6765 17.0095 20.2271 17.0095 19.9499 17.28L18.5592 18.6369L18.1146 18.2031C17.8374 17.9326 17.388 17.9326 17.1108 18.2031C16.8336 18.4735 16.8336 18.912 17.1108 19.1825L18.0569 20.1055C18.195 20.2403 18.3766 20.3086 18.5583 20.3086C18.7399 20.3086 18.9215 20.2412 19.0597 20.1055L20.9518 18.2594C21.229 17.9889 21.229 17.5505 20.9518 17.28H20.9537Z",
    fill: "#039855"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtUser05Tick);
export default __webpack_public_path__ + "static/media/at_user-05-tick.4c28cf243f770b89cfa1469976cc5b7b.svg";
export { ForwardRef as ReactComponent };